import { useEffect, useState } from "react";

export function useThemeColors() {
  const [colors, setColors] = useState(() => getThemeColors());

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setColors(getThemeColors());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return colors;
}

function getThemeColors() {
  if (typeof window === "undefined") {
    return {
      textPrimary: "#f8fafc",
      textSecondary: "#94a3b8",
      textMuted: "#475569",
      surface: "#0f172a",
      surfaceElevated: "#1e293b",
      border: "#1e293b",
      brandCyan: "#06b6d4",
      brandViolet: "#8b5cf6",
      brandAmber: "#f59e0b",
      brandRose: "#f43f5e",
      brandEmerald: "#10b981",
      brandBlue: "#3b82f6",
      chartRed: "#ef4444",
      chartOrange: "#f97316",
      chartAmber: "#f59e0b",
      chartYellow: "#eab308",
      chartLime: "#84cc16",
      chartGreen: "#10b981",
      chartCyan: "#06b6d4",
      chartBlue: "#3b82f6",
      chartViolet: "#8b5cf6",
      chartPurple: "#a855f7",
      chartPink: "#ec4899",
    };
  }

  const root = document.documentElement;
  const style = getComputedStyle(root);

  return {
    textPrimary: style.getPropertyValue("--text-primary").trim() || "#0f172a",
    textSecondary: style.getPropertyValue("--text-secondary").trim() || "#334155",
    textMuted: style.getPropertyValue("--text-muted").trim() || "#64748b",
    surface: style.getPropertyValue("--surface").trim() || "#ffffff",
    surfaceElevated: style.getPropertyValue("--surface-elevated").trim() || "#f1f5f9",
    border: style.getPropertyValue("--border").trim() || "#e2e8f0",
    brandCyan: "#06b6d4",
    brandViolet: "#8b5cf6",
    brandAmber: "#f59e0b",
    brandRose: "#f43f5e",
    brandEmerald: "#10b981",
    brandBlue: "#3b82f6",
    chartRed: "#ef4444",
    chartOrange: "#f97316",
    chartAmber: "#f59e0b",
    chartYellow: "#eab308",
    chartLime: "#84cc16",
    chartGreen: "#10b981",
    chartCyan: "#06b6d4",
    chartBlue: "#3b82f6",
    chartViolet: "#8b5cf6",
    chartPurple: "#a855f7",
    chartPink: "#ec4899",
  };
}
